/**
 * UI constant for account deletion confirmation (API requires confirmation === "DELETE").
 * Request/response types come from we-tree-api-client/v2.
 */
export const ACCOUNT_DELETE_CONFIRMATION = 'DELETE' as const;
